import perspective from "./perspective";
import theme from "./theme";
import pillar from "./pillars";
import so from "./so";
import user from "./user";
import kpi from "./kpi";
import kpiType from "./kpiType";
import sysPerf from "./sysPerf";
import orgStructure from "./orgStructure";
import group from "./group";
import handshake from "./handshake";
import notification from "./notification";
import dashboard from "./dashboard";
import attachment from "./attachment";
import weight from "./weight";
import workflow from "./workflow";
import strategyMap from "./strategyMap";
import delegation from "./delegation";
import auth from "./auth";
import strategy from "./strategy";
import subSo from "./subSo";
import pPlus from "./pplus";
import processes from "./processes";
import programs from "./programs";
import initiatives from "./initiatives";
import taskCenter from "./taskCenter";
import kpiDashboard from "./kpiDashboard";
import report from "./report";
import objective from "./objective";

const api = {
  perspective,
  theme,
  pillar,
  so,
  user,
  kpi,
  kpiType,
  sysPerf,
  orgStructure,
  group,
  handshake,
  notification,
  dashboard,
  attachment,
  weight,
  workflow,
  strategyMap,
  delegation,
  auth,
  strategy,
  subSo,
  pPlus,
  processes,
  programs,
  initiatives,
  taskCenter,
  kpiDashboard,
  report,
  objective,
};

export default api;
